import React from 'react';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';

function ViewChanger() {
  const {
    currentView,
    setCurrentView,
    fileManagerFilters,
    getFiles,
    pageLimit,
    isGlobalFileManager,
    caseDetails,
    isClientFileManager,
    query,
  } = useFileManagerContext();

  return (
    <div className="d-flex align-items-center justify-content-end gap-2 change-view ms-lg-2">
      <Button
        onClick={() => {
          setCurrentView('list');
          let obj = {
            case_id: isGlobalFileManager || isClientFileManager ? fileManagerFilters?.case?.id || '' : caseDetails?.case_id,
            selectedFolder: fileManagerFilters.selectedFolder,
            selectedType: fileManagerFilters.fileType,
            tag: fileManagerFilters.tag,
            query: query,
            limit: pageLimit,
            is_read: isGlobalFileManager ? fileManagerFilters?.is_read : fileManagerFilters?.fileStatus,
          };
          getFiles(obj, 'list', pageLimit);
        }}
        className={`list-view ${currentView === 'list' ? 'highlight' : ''}`}
      >
        <Tooltip content="List view" position="top" target=".list-view" showDelay={500} />
        <i className="icon-List-view"></i>
      </Button>

      <Button
        onClick={() => {
          setCurrentView('grid');
          let obj = {
            case_id: isGlobalFileManager || isClientFileManager ? fileManagerFilters?.case?.id || '' : caseDetails.case_id,
            selectedFolder: fileManagerFilters.selectedFolder,
            selectedType: fileManagerFilters.fileType,
            tag: fileManagerFilters.tag,
            query: query,
            limit: pageLimit,
            is_read: isGlobalFileManager ? fileManagerFilters?.is_read : fileManagerFilters?.fileStatus,
          };
          getFiles(obj, 'grid', pageLimit);
        }}
        className={`grid-view  ${currentView === 'grid' ? 'highlight' : ''}`}
      >
        <Tooltip content="Grid view" position="top" target=".grid-view" showDelay={500} />
        <i className="icon-grid-view"></i>
      </Button>
    </div>
  );
}

export default ViewChanger;
